<template>
    <div class="auditResult">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="body">
            <div>
                <img :src="successUrl" alt="">
                <div class="result">实名认证成功</div>
                <span class="tips">实名认证成为会员，享会员专享价，拿返利</span>
            </div>
            <button @click="clickHandle">去购物</button>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
export default {
    name: 'auditResult',
    data () {
        return {
            title: '认证结果',
            result: '',
            successUrl: require('../../../assets/img/b2b/img_right@2x.png'),
            userType: parseInt(this.$route.query.userType) || 11
        }
    },
    components: {
        Header
    },
    beforeRouteLeave (to, from, next) {
        if (to.name === 'home') {
            to.meta.isPage = true
        }
        next()
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/company/index' })
        },
        clickHandle () {
            this.$router.push({ path: '/b2b/home/index' })
        }
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>
.auditResult {
    height: 100%;
    background-color: #fff;
}
.body {
    margin-top: 120px;
    text-align: center;
    img {
        width: 144px;
        height: 144px;
    }
    .result {
        color: #000000;
        font-size: 36px;
        font-weight: 400;
        margin: 48px 0 16px 0;
    }
    .tips {
        color: #8e8e93;
        font-size: 28px;
        font-weight: 400;
    }
    .errtips {
        color: #FF3B30;
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    button {
        padding: 26px 200px;
        color: #ff7a45;
        border: 2px solid #ff7a45;
        border-radius: 40px;
        background-color: #fff;
        margin-top: 102px;
    }
}
</style>